// Device-local current month (no UTC day/month shift). en-CA formats as YYYY-MM-DD.
export const todayLocalISO = () => new Date().toLocaleDateString("en-CA");
export const currentMonth = () => todayLocalISO().slice(0, 7);
export const DEMO_MONTH = currentMonth();

export const money = (c) => {
  const n = Math.abs(Math.round(c || 0));
  const s = `$${Math.floor(n / 100).toLocaleString("en-AU")}.${String(n % 100).padStart(2, "0")}`;
  return (c < 0 ? "-" : "") + s;
};

export const moneyShort = (c) => {
  const n = Math.round((c || 0) / 100);
  return `$${n.toLocaleString("en-AU")}`;
};

export const parseMoneyToCents = (v) => {
  const n = parseFloat(String(v).replace(/[^0-9.\-]/g, ""));
  return isNaN(n) ? 0 : Math.round(n * 100);
};

export const parsePctToBps = (v) => {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : Math.round(n * 100);
};

export const bpsToPct = (b) => (b == null ? "" : String(b / 100));
export const centsToInput = (c) => (c == null ? "" : (c / 100).toFixed(2));

export const fmtDateAU = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return `${d}/${m}/${y}`;
};

export const fmtDayLong = (iso) => {
  if (!iso) return "";
  const d = new Date(String(iso).slice(0, 10) + "T00:00:00");
  return d.toLocaleDateString("en-AU", { weekday: "long", day: "numeric", month: "short" });
};

export const monthLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString("en-AU", { month: "long", year: "numeric" });
};

export const addMonth = (ym, delta) => {
  const [y, m] = ym.split("-").map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};

export const fyLabel = (ym) => {
  const [y, m] = ym.split("-").map(Number);
  const sy = m >= 7 ? y : y - 1;
  return `FY ${sy}/${String((sy + 1) % 100).padStart(2, "0")}`;
};

export const STATUS_META = {
  expected: { label: "Expected", tone: "slate" },
  partially_paid: { label: "Partially Paid", tone: "amber" },
  paid: { label: "Paid", tone: "green" },
  difference: { label: "Difference", tone: "red" },
  overdue: { label: "Overdue", tone: "red" },
  explained: { label: "Explained", tone: "indigo" },
};
